import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Sparkles } from "lucide-react";
const BILLING_URL = "https://shondalai.com/account#/account/aicredits";
function AiCreditsBadge({
  enabled,
  available,
  isLoading = false,
  isError = false,
  labels,
  className,
  style
}) {
  if (!enabled) return null;
  const unavailable = isError || available == null || !Number.isFinite(available) || available < 0;
  const tone = isLoading ? "loading" : unavailable ? "unavailable" : available === 0 ? "empty" : available < 50 ? "low" : "healthy";
  const title = tone === "loading" ? labels.loading : tone === "unavailable" ? labels.unavailable : tone === "empty" ? labels.empty : labels.balance(available);
  const count = tone === "loading" ? "…" : tone === "unavailable" ? "!" : formatCredits(available);
  const warning = tone === "low" || tone === "unavailable";
  const color = tone === "empty" ? "var(--ai-credits-danger, #d14343)" : warning ? "var(--ai-credits-warning, #b77914)" : "inherit";
  const badgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    gap: 5,
    height: 26,
    boxSizing: "border-box",
    padding: "0 8px",
    border: "1px solid color-mix(in srgb, currentColor 20%, transparent)",
    borderRadius: 4,
    background: tone === "empty" || tone === "low" ? "color-mix(in srgb, currentColor 6%, transparent)" : "transparent",
    color,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1,
    textDecoration: "none",
    whiteSpace: "nowrap",
    ...tone === "unavailable" ? { borderStyle: "dashed" } : {},
    ...style
  };
  const content = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Sparkles,
      {
        "aria-hidden": "true",
        size: 12,
        style: { flexShrink: 0, color: tone === "healthy" ? "var(--ai-credits-accent, #57876c)" : "currentColor" }
      }
    ),
    /* @__PURE__ */ jsx("span", { style: { fontFamily: "ui-monospace, monospace", fontVariantNumeric: "tabular-nums" }, children: count })
  ] });
  if (isLoading) {
    return /* @__PURE__ */ jsx("span", { className, style: badgeStyle, title, "aria-label": title, "aria-busy": "true", children: content });
  }
  return /* @__PURE__ */ jsx(
    "a",
    {
      href: BILLING_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      className: ["ui-ai-credits-badge", className].filter(Boolean).join(" "),
      style: badgeStyle,
      title,
      "aria-label": title,
      children: content
    }
  );
}
function formatCredits(count) {
  if (count < 1e3) return String(count);
  return `${(count / 1e3).toFixed(1).replace(/\.0$/, "")}k`;
}
export {
  AiCreditsBadge
};
//# sourceMappingURL=ai-credits-badge.js.map
